//import { mode } from '@chakra-ui/theme-tools'
const Button = {
    // The styles all button have in common
    baseStyle: (props: any) => ({
      fontWeight: 'bold',
      //textTransform: 'uppercase',
      borderRadius: 'md', // <-- border radius is same for all variants and sizes
      color: 'white',
      _hover: {
        bg: 'blue.500',
      }
    }),
    // Two sizes: sm and md
    sizes: {
      sm: {
        fontSize: 'sm',
        px: 4, // <-- px is short for paddingLeft and paddingRight
        py: 3, // <-- py is short for paddingTop and paddingBottom
      },
      md: {
        fontSize: 'md',
        px: 6, // <-- these values are tokens from the design system
        py: 4, // <-- these values are tokens from the design system
      },
    },
    // Two variants: outline and solid
    /*variants: { 
      outline: (props: any) => ({
        border: '2px solid',
        borderColor: mode('purple.500', 'red.500')(props),
        color: 'purple.500',
      }),
     
      solid: (props: any) => ({
        fontWeight: 'slim',
        bg: mode('#004080', 'white')(props),
        color: mode('white', '#06c')(props),
        borderColor: '#06c',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,.15),0 1px 1px rgba(0,0,0,.075)',
        "_hover": {
            bg: mode('#004d99', 'white')(props),
            color: mode('white', 'black')(props)
        },
        "_active": {
            bg: '#004d99',
            boxShadow: 'inset 0 3px 5px rgba(0,0,0,.125)',
        },
      })
    },*/
    // The default size and variant values
    defaultProps: {
      size: 'md',
      colorScheme: 'pa'
    },
}

export default Button